export const replacePlaceholders = (
    string,
    placeholders
) => {
    if (!string) return "";
    const regexp = /{{[\w{}]+}}/g;
    return string
        .replace(regexp, key => {
            const strippedKey = key.replace(/[{}]/g, '');
            return placeholders[strippedKey] || strippedKey;
        })
};
